import { Outlet, useLocation } from 'react-router-dom';
import React from 'react';
import { StoreType, TreeType } from '../../store/spirs/types';
import { useDispatch, useSelector } from 'react-redux';
import { CHANGE_TREE_TYPE, startTreePolling, stopTreePolling } from '../../store/spirs/actions';
import { TREE_LIVE_TYPE } from '../../models/api/codegen/code';
import { changeHeaderPlayer } from '../../spirsApi/api-client';

const getType  = (path: string): TreeType => {
    if (path.startsWith("/sport/live")) {
        return "LIVE"
    } else if (path.startsWith("/sport/prematch")) {
        return "PREMATCH";
    } else if (path.startsWith("/sport/rating")) {
        return "RATING_PREMATCH";
    }
    return "NONE";
}

const getLiveType  = (path: string): TREE_LIVE_TYPE => {
    if (path.startsWith("/sport/live-top")) {
        return TREE_LIVE_TYPE.LIVE_RATING
    } else if (path.startsWith("/sport/live-widget")) {
        return TREE_LIVE_TYPE.LIVE_WIDGET;
    }
    return TREE_LIVE_TYPE.LIVE;
}

export const TreeMaster: React.FC = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const type = React.useMemo(() => getType(location.pathname), [location.pathname]);
    const liveType = React.useMemo(() => getLiveType(location.pathname), [location.pathname]);
    const time = useSelector((state: StoreType) => state.spirs.timePeriodReducer)
    const { playerInfo: {playerId}, playerToken  } = useSelector((state: StoreType) => state.spirs);

    React.useEffect(() => {
        changeHeaderPlayer(playerId ? playerId : 'GUEST', playerToken)

        dispatch(CHANGE_TREE_TYPE(type));
        dispatch(startTreePolling({type, liveType, time}))
        return () => {
            dispatch(CHANGE_TREE_TYPE("NONE"));
            dispatch(stopTreePolling())
        }
    }, [type, liveType, time, playerId, playerToken])

    return <Outlet/>
}